import { render, staticRenderFns } from "./_shop_menu.vue?vue&type=template&id=09882255&v-if=fetch_data&"
import script from "./_shop_menu.vue?vue&type=script&lang=js&"
export * from "./_shop_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports